/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event) {
    var mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        // GSAP cta parallax animations
        var ctaParallaxContainer = document.querySelector('.wp-block-create-block-mq20-cta-parallax');
        var ctaParallaxHeading = document.querySelector('.cta-parallax-header-content h2');
        var ctaParallaxHeadingAnimated = new SplitType(ctaParallaxHeading);
        var ctaParallaxParagraph = document.querySelector('.cta-parallax-header-content p');
        var ctaParallaxButton = document.querySelector('.cta-parallax-header-content .cta-parallax-button');

        function initCtaScrollScrollAnimation() {
            var ctaParallaxScrollAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ctaParallaxContainer,
                    start: "top +=90%",
                    end: "bottom bottom"
                }
            });

            var headingAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut"
            };

            gsap.fromTo(ctaParallaxHeadingAnimated.chars, {
                y: 20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                ease: "power3.inOut",
                stagger: 0.01,
                scrollTrigger: {
                    trigger: ctaParallaxContainer,
                    start: "top +=85%",
                    end: "bottom bottom"
                }
            });

            ctaParallaxScrollAnimationTimeline
                .from(ctaParallaxParagraph, {...headingAnimationProps, delay: 0.1})
                .from(ctaParallaxButton, {...headingAnimationProps, delay: 0.1});
        }

        initCtaScrollScrollAnimation();
    });

    mm.add("(min-width: 769px)", () => {
        var ctaParallaxImageContainer = document.querySelector('.cta-parallax-items');
        var ctaParallaxImage01 = document.querySelector('.cta-parallax-item-image-01');
        var ctaParallaxImage02 = document.querySelector('.cta-parallax-item-image-02');
        var ctaParallaxImage03 = document.querySelector('.cta-parallax-item-image-03');
        var ctaParallaxImage04 = document.querySelector('.cta-parallax-item-image-04');
        var ctaParallaxImage05 = document.querySelector('.cta-parallax-item-image-05');
        var ctaParallaxImage06 = document.querySelector('.cta-parallax-item-image-06');

        function initParallaxAnimation(){
            var ctaParallaxScrollAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ctaParallaxImageContainer,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    toggleActions: "play play reverse reverse"
                }
            });

            ctaParallaxScrollAnimationTimeline
                .fromTo(ctaParallaxImage01, { yPercent: -30 }, { yPercent: 30 }, 0)
                .fromTo(ctaParallaxImage02, { yPercent: -20 }, { yPercent: 20 }, 0)
                .fromTo(ctaParallaxImage03, { yPercent: -40 }, { yPercent: 40 }, 0)
                .fromTo(ctaParallaxImage04, { yPercent: -60 }, { yPercent: 60 }, 0)
                .fromTo(ctaParallaxImage05, { yPercent: -25 }, { yPercent: 25 }, 0)
                .fromTo(ctaParallaxImage06, { yPercent: -40 }, { yPercent: 40 }, 0);
        }

        initParallaxAnimation();
    });

    mm.add("(max-width: 768px)", () => {
        var ctaParallaxImageMobileContainer = document.querySelector('.cta-parallax-items-mobile');
        var ctaParallaxImage01Mobile = document.querySelector('.cta-parallax-item-image-01-mobile');
        var ctaParallaxImage02Mobile = document.querySelector('.cta-parallax-item-image-02-mobile');
        var ctaParallaxImage03Mobile = document.querySelector('.cta-parallax-item-image-03-mobile');
        var ctaParallaxImage04Mobile = document.querySelector('.cta-parallax-item-image-04-mobile');


        function initParallaxAnimation(){
            var ctaParallaxScrollMobileAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ctaParallaxImageMobileContainer,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    toggleActions: "play play reverse reverse"
                }
            });

            ctaParallaxScrollMobileAnimationTimeline
                .fromTo(ctaParallaxImage01Mobile, { yPercent: -30 }, { yPercent: 30 }, 0)
                .fromTo(ctaParallaxImage02Mobile, { yPercent: -25 }, { yPercent: 25 }, 0)
                .fromTo(ctaParallaxImage03Mobile, { yPercent: -15 }, { yPercent: 15 }, 0)
                .fromTo(ctaParallaxImage04Mobile, { yPercent: -10 }, { yPercent: 10 }, 0);
        }

        initParallaxAnimation();

    });
});
